import React from 'react';
import './TimePicker.css';
import { getTranslate } from 'react-localize-redux';
import { connect } from 'react-redux';

class TimePicker extends React.Component {
  constructor(props, state) {
    super(props, state);
    this.state = {
      hour: '',
      min: '',
    };
  }

    pickedTime = (evt) => {
      const now = new Date();
      const { restTimePicker } = this.props;
      const { hour, min } = this.state;
      const {
        selectedTime, isStartTime, currentStartTimeFromDB, currentEndTimeFromDB,
      } = this.props;
      const startDate = currentStartTimeFromDB;
      const endDate = currentEndTimeFromDB;
      if (restTimePicker) {
        if (evt.target.className === 'hour-selector') {
          this.setState({ hour: evt.target.value });
        } else if (evt.target.className === 'minute-selector') {
          this.setState({ min: evt.target.value });
        }
        selectedTime({
          pickedTime: new Date(now.getFullYear(), now.getMonth(), now.getDate(), hour, min, now.getSeconds(), now.getMinutes()),
          isStartTime,
        });
      } else if (!restTimePicker) {
        if (evt.target.className === 'hour-selector') {
          this.setState({ hour: evt.target.value });
          if (isStartTime && startDate !== undefined && min === '') {
            this.setState({ min: startDate.getMinutes() });
          } else if (!isStartTime && endDate !== undefined && min === '') {
            this.setState({ min: endDate.getMinutes() });
          }
        } else if (evt.target.className === 'minute-selector') {
          this.setState({ min: evt.target.value });
          if (isStartTime && startDate !== undefined && hour === '') {
            this.setState({ hour: startDate.getHours() });
          } else if (!isStartTime && endDate !== undefined && hour === '') {
            this.setState({ hour: endDate.getHours() });
          }
        }
        selectedTime({
          pickedTime: new Date(now.getFullYear(), now.getMonth(), now.getDate(), hour, min, now.getSeconds(), now.getMinutes()),
          isStartTime,
        });
      }
    }

    generateTimeData = (typeOfData, steps) => {
      const timeData = [];
      timeData.push({ value: '-', label: '-----' });
      let counter = 0;
      for (let i = 0; i < (typeOfData === 'hour' ? 24 : 60); i++) {
        if (steps !== 0) {
          if (steps === counter) {
            timeData.push({ value: (i < 10 ? `0${i}` : i), label: (i < 10 ? `0${i}` : i) });
            counter = 0;
          }
          counter++;
        } else {
          timeData.push({ value: (i < 10 ? `0${i}` : i), label: (i < 10 ? `0${i}` : i) });
        }
      }
      return timeData;
    }

    render() {
      const { currentHour, currentMin, required } = this.props;
      return (
        <div className="time-picker">
          <select className="hour-selector" required={required} onChange={this.pickedTime} onClick={this.pickedTime}>
            {this.generateTimeData('hour', 0).map((timeData, i) => {
              if (currentHour === null && i === 0) {
                return <option key={i} selected value=""> ----- </option>;
              } if (i === 0) {
                return <option key={i} value=""> ----- </option>;
              }
              if (parseInt(timeData.value, 10) === currentHour) {
                return (
                  <option key={i} selected value={timeData.label}>
                    {' '}
                    {timeData.value}
                    {' '}
                  </option>
                );
              }

              return (
                <option key={i} value={timeData.label}>
                  {' '}
                  {timeData.value}
                  {' '}
                </option>
              );
            })}
          </select>
          <span className="hour-min-seperator">:</span>
          <select className="minute-selector" required={required} onChange={this.pickedTime} onClick={this.pickedTime}>
            {this.generateTimeData('', 0).map((timeData, i) => {
              if (currentMin === null && i === 0) {
                return <option key={i} selected value=""> ----- </option>;
              } if (i === 0) {
                return <option key={i} value=""> ----- </option>;
              }
              // eslint-disable-next-line
                        if(parseInt(timeData.value) === currentMin) {
                return (
                  <option key={i} selected value={timeData.label}>
                    {' '}
                    {timeData.value}
                    {' '}
                  </option>
                );
              }

              return (
                <option key={i} value={timeData.label}>
                  {' '}
                  {timeData.value}
                  {' '}
                </option>
              );
            })}
          </select>
        </div>
      );
    }
}

const mapStateToProps = (state = {}) => {
  const locale = state.locale || {};
  return {
    translate: getTranslate(locale),
  };
};

export default connect(
  mapStateToProps,
  null,
)(TimePicker);
